import React from 'react'
import loadingIcon from '/app/assets/images/insurance/icons/loader.gif'

const SkeletonItem = ({ width, height, borderRadius }) => (
  <div style={{ width, height, borderRadius, background: '#F0F0F0' }}></div>
)

const LoaderGif = () => {
  return (
    <div
      style={{
        borderRadius: 6,
        padding: '6px 12px',
        width: 'fit-content',
        background: 'var(--fill, #F9F9F9)',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.10)',
      }}
      className="dome-d-flex dome-flex-column dome-align-center"
    >
      <img src={loadingIcon} width={50} height={50} alt='loading icon'/>
      <div className="dome-d-flex dome-flex-column dome-align-center dome-gap3">
        <span className="dome-p1 dome-color-dark-grey">payment loading...</span>
        <span className="dome-p3 dome-color-dark-grey">please do not refresh this page</span>
      </div>
    </div>
  )
}

export default function PaymentLoading() {
  return (
    <div
      style={{
        borderRadius: 6,
        background: 'white',
        padding: '24px 18px',
        width: 'calc(100% - 375px)',
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.10)',
      }}
      className="dome-relative"
    >
      <div style={{ position: 'absolute', top: 90, left: '50%', transform: 'translateX(-50%)' }}>
        <LoaderGif />
      </div>
      <div className="dome-d-flex dome-flex-column dome-gap18">
        <div className="dome-d-flex dome-gap6">
          <SkeletonItem width={23} height={22} borderRadius={45} />
          <SkeletonItem width={265} height={22} borderRadius={45} />
        </div>
        <SkeletonItem width={315} height={22} borderRadius={45} />
        <SkeletonItem width={'93%'} height={45} borderRadius={6} />
        <SkeletonItem width={129} height={22} borderRadius={45} />
        <SkeletonItem width={66} height={22} borderRadius={45} />
        <SkeletonItem width={'100%'} height={114} borderRadius={6} />
      </div>
    </div>
  )
}
